/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface ICommentThreadConfigurationScope extends ng.IScope {
        processConfigurationId: string;
        openCanCommentSecurityMatrix: any;
        openCanDeleteSecurityMatrix: any;
        openCanViewDeleteSecurityMatrix: () => void;
        emailConfigurations: Wars.Domain.Model.EmailConfiguration[];
        reviewConfigurations: Wars.Domain.Model.Reviews.ReviewConfiguration[];
        configuration:Wars.Domain.Model.CommentThreadConfiguration;
        save: any;
    }

    export class CommentThreadConfiguration implements IDirective {
        public link($scope: IManageCommentThreadScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/commentThreadConfiguration.html";
        public controller = [
          "$scope", "securityMatrixService", "emailConfigurationService", "reviewConfigurationService", "systemLevelService", CommentThreadConfigurationController
        ];
        public controllerAs = "controller";
        public restrict: string = "E";
        public scope: any = {
            configuration: "=",
            processConfigurationId: "="
        };
    }

    export class CommentThreadConfigurationController {

        constructor(
            private scope: ICommentThreadConfigurationScope,
            private securityMatrixService: services.SecurityMatrixService,
            private emailConfigurationService: services.EmailConfigurationService,
            private reviewConfigurationService: services.ReviewConfigurationService,
            private systemLevelService: services.SystemLevelService) {

            scope.openCanCommentSecurityMatrix = () => this.openCanCommentSecurityMatrix();
            scope.openCanDeleteSecurityMatrix = () => this.openCanDeleteSecurityMatrix();
            scope.openCanViewDeleteSecurityMatrix = () => this.openCanViewDeleteSecurityMatrix();
            scope.save = () => this.save();

            emailConfigurationService.getAllEmailConfigurationsByProcessId(this.scope.processConfigurationId)
                .then(e => {
                  this.scope.emailConfigurations = e;
                  this.systemLevelService.getSystemEmailConfigurations().then(system => {
                    this.scope.emailConfigurations.addRange(system.myEmailConfigurations);
                  });
                });

            reviewConfigurationService.getReviewConfigurations(this.scope.processConfigurationId)
                .then(r => {
                    this.scope.reviewConfigurations = r;
                });
        }

        private openCanCommentSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.scope.configuration.canCommentSecurityMatrix, this.scope.processConfigurationId);
        }

        private openCanDeleteSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.scope.configuration.canDeleteSecurityMatrix, this.scope.processConfigurationId);
        }

        private openCanViewDeleteSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.scope.configuration.canViewDeletedCommentsSecurityMatrix, this.scope.processConfigurationId);
        }

        private save() {
            this.securityMatrixService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('CommentThreadConfiguration', []);